import { useEffect } from 'react'
import { type DeviceInfo, enumerateDevices, onDeviceChange } from '@/shared/lib/livekit'
import { useDeviceSelection } from '../model/device-store'

// Пикер устройств в звонке смонтирован только пока открыт диалог настроек, а
// гарнитуру выдёргивают когда угодно. Подписка живёт всю комнату и возвращает
// выбор на системное, как только железо пропало; перечисление без getUserMedia —
// промпт в середине звонка человеку не нужен.
export function useDeviceHotplug(): void {
  useEffect(() => {
    let cancelled = false

    async function sync() {
      const devices = await enumerateDevices().catch(() => [] as DeviceInfo[])
      if (!cancelled) useDeviceSelection.getState().keepPresent(devices)
    }

    void sync()
    const off = onDeviceChange(() => void sync())
    return () => {
      cancelled = true
      off()
    }
  }, [])
}
